if (!customElements.get('m-faq-section')) {
  class MFaqSection extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this._onKeyDown = this._onKeyDown.bind(this);
      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeyDown);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      this.removeEventListener('keydown', this._onKeyDown);
    }

    _onClick(event) {
      const trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger || !this.contains(trigger)) return;
      event.preventDefault();
      this.toggleItem(trigger.closest('[data-faq-item]'));
    }

    _onKeyDown(event) {
      const trigger = event.target.closest('[data-faq-trigger]');
      if (!trigger || !this.contains(trigger)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.toggleItem(trigger.closest('[data-faq-item]'));
    }

    toggleItem(item) {
      if (!item) return;

      const trigger = item.querySelector('[data-faq-trigger]');
      const panel = item.querySelector('[data-faq-panel]');
      if (!trigger || !panel) return;

      const isOpen = item.classList.contains('is-open');

      this.querySelectorAll('[data-faq-item].is-open').forEach((openItem) => {
        if (openItem === item) return;
        this.closeItem(openItem);
      });

      if (isOpen) {
        this.closeItem(item);
      } else {
        this.openItem(item);
      }
    }

    openItem(item) {
      const trigger = item.querySelector('[data-faq-trigger]');
      const panel = item.querySelector('[data-faq-panel]');
      if (!trigger || !panel) return;

      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      panel.style.height = '0px';

      requestAnimationFrame(() => {
        panel.style.height = panel.scrollHeight + 'px';
      });

      const onEnd = (event) => {
        if (event.target !== panel) return;
        panel.removeEventListener('transitionend', onEnd);
        if (!item.classList.contains('is-open')) return;
        panel.style.height = 'auto';
      };
      panel.addEventListener('transitionend', onEnd);
    }

    closeItem(item) {
      const trigger = item.querySelector('[data-faq-trigger]');
      const panel = item.querySelector('[data-faq-panel]');
      if (!trigger || !panel) return;

      trigger.setAttribute('aria-expanded', 'false');
      panel.style.height = panel.scrollHeight + 'px';

      requestAnimationFrame(() => {
        item.classList.remove('is-open');
        panel.style.height = '0px';
      });

      const onEnd = (event) => {
        if (event.target !== panel) return;
        panel.removeEventListener('transitionend', onEnd);
        if (item.classList.contains('is-open')) return;
        panel.hidden = true;
      };
      panel.addEventListener('transitionend', onEnd);
    }
  }

  customElements.define('m-faq-section', MFaqSection);
}
